<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="6">
        <v-card-title>
          User Group
        </v-card-title>
      </v-col>
      <v-col cols="6">
        <template>
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
              :headers="headers"
              :items="groupsWithIndex"
              class="elevation-1"
              :search="search"
              dense
              mobile-breakpoint="0"
              :loading="loading_status"
              loading-text="Loading... Please wait"
          >
          </v-data-table>

        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      items: [
        {text: "Dashboard", disabled: false, href: "/"},
        {text: "Users", disabled: true, href: null},
        {text: "Group List", disabled: true, href: ""},
      ],
      search: "",
      headers: [
        {text: "SL", value: "index"},
        {text: "Name", value: "name"}
      ],
      groups: [],
      loading_status: true,
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.getGroupList();
    },
    getGroupList() {
      atshq.get("users/group-list")
          .then((response) => {
            this.groups = response.data.groups
            this.loading_status = false
          }).catch((e) => {
            this.$noty.error(e.message);
            this.loading_status = false
      });
    },
  },
  computed: {
    groupsWithIndex() {
      return this.groups.map((group, index) => ({
        index: index + 1,
        ...group
      }))
    }
  }

}
</script>